import { action, createRequestTypes } from '@/utils/actions.utils'
import { projectsService } from '@/services'

export const FETCH_PROJECT_TYPES = createRequestTypes('FETCH_PROJECT_TYPES')
const fetchProjectTypes = ({ lang, catalogId }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())
			const res = await projectsService.fetchProjectTypes({ lang, catalogId })
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(FETCH_PROJECT_TYPES.REQUEST)
	}
	function success(payload) {
		return action(FETCH_PROJECT_TYPES.SUCCESS, payload)
	}
	function failure(err) {
		return action(FETCH_PROJECT_TYPES.FAILURE, null, err)
	}
}

export const FETCH_PROJECT_LIST = createRequestTypes('FETCH_PROJECT_LIST')
const fetchProjectList = ({
	itemsToLoad,
	itemsPerPage,
	page,
	search,
	language,
	sortBy,
	resetList = false,
	projectUserRole
}) => {
	return async (dispatch) => {
		if (resetList) {
			dispatch(projectsActions.emptyProjectList())
		}

		try {
			await dispatch(request({ itemsToLoad, resetList }))

			const res = await projectsService.fetchProjectList({
				itemsPerPage,
				page,
				search,
				language,
				sortBy,
				projectUserRole
			})

			return dispatch(
				success({
					itemsToLoad,
					...res.data
				})
			)
		} catch (error) {
			return dispatch(failure({ itemsToLoad }, error))
		}
	}

	function request(payload) {
		return action(FETCH_PROJECT_LIST.REQUEST, payload)
	}
	function success(payload) {
		return action(FETCH_PROJECT_LIST.SUCCESS, payload)
	}
	function failure(payload, err) {
		return action(FETCH_PROJECT_LIST.FAILURE, payload, err)
	}
}


export const GENERATE_QUOTE_NUMBER = createRequestTypes('GENERATE_QUOTE_NUMBER')
const generateQuoteNumber = () => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await projectsService.generateQuoteNumber()
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}
	function request() {
		return action(GENERATE_QUOTE_NUMBER.REQUEST)
	}
	function success(payload) {
		return action(GENERATE_QUOTE_NUMBER.SUCCESS, payload)
	}
	function failure(err) {
		return action(GENERATE_QUOTE_NUMBER.FAILURE, err)
	}
}

export const FETCH_PROJECTS_NAME = createRequestTypes('FETCH_PROJECTS_NAME')
const fetchProjectsName = () => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await projectsService.fetchProjectsName()
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(FETCH_PROJECTS_NAME.REQUEST)
	}
	function success(payload) {
		return action(FETCH_PROJECTS_NAME.SUCCESS, payload)
	}
	function failure(err) {
		return action(FETCH_PROJECTS_NAME.FAILURE, null, err)
	}
}

export const IMPORT_THIRD_PARTY_PROJECT = createRequestTypes('IMPORT_THIRD_PARTY_PROJECT')
const importThirdPartyProject = ({ projectId, lang }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await projectsService.importThirdPartyProject({
				projectId,
				lang
			})
			return dispatch(success(res.response))
		} catch (error) {
			dispatch(failure(error))
		}
	}

	function request() {
		return action(IMPORT_THIRD_PARTY_PROJECT.REQUEST)
	}
	function success(payload) {
		return action(IMPORT_THIRD_PARTY_PROJECT.SUCCESS, payload)
	}
	function failure(err) {
		return action(IMPORT_THIRD_PARTY_PROJECT.FAILURE, null, err, false)
	}
}

export const EMPTY_PROJECTS_LIST = 'EMPTY_PROJECTS_LIST'
const emptyProjectList = () => {
	return {
		type: EMPTY_PROJECTS_LIST
	}
}

const projectsActions = {
	emptyProjectList,
	fetchProjectList,
	generateQuoteNumber,
	fetchProjectsName,
	fetchProjectTypes,
	importThirdPartyProject
}

export default projectsActions
